var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35554 9.80591C8.05148 9.39803 8.94852 9.39803 9.64446 9.80591L15.0871 12.9957C15.3446 13.1466 15.5 13.4048 15.5 13.6817C15.5 14.1336 15.0937 14.5 14.5925 14.5H2.40751C1.9063 14.5 1.5 14.1336 1.5 13.6817C1.5 13.4048 1.65538 13.1466 1.91293 12.9957L7.35554 9.80591Z",
    fill: "white",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.5C8.5 8.5 10.5 5.60457 10.5 4.5C10.5 3.39543 9.60457 2.5 8.5 2.5C7.39543 2.5 6.5 3.39543 6.5 4.5",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct3);
export default __webpack_public_path__ + "static/media/Product (3).c6dcdfbdae1c7a3288849c3a778e624b.svg";
export { ForwardRef as ReactComponent };